import {
  Button,
  DatePicker,
  Select,
  Skeleton,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  formatDateAndTime,
  getLocalStorageItem,
  trimString,
} from "../../../Utils";
import {
  getmemberFilterList,
  getUtiReport,
  getXpressPayoutReport,
} from "../../../ApiServices/Apifun";
import dayjs from "dayjs";
import ReportDrawer from "../../../Common/ReportDrawer";
import { AiOutlineSearch } from "react-icons/ai";
import { Images } from "../../../Controller";
import Content from "../../../Common/ReceiptContent";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import { FaEye } from "react-icons/fa6";
import { APIURL } from "../../../ApiServices/Axios";
import { Globalendpoints } from "../../../ApiServices/global";
import axios from "axios";
import CommonAmountPage from "../../../Common/CommonAmountPage";

const XpressPayoutReport = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [totalAmt, setTotalAmt] = useState();
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [memberOptions, setMemberOptions] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const [searchdropdown, setSearchdropdown] = useState(null);
  const [amountData, setAmountData] = useState({});

  const dropdown = [
    {
      label: "Successful",
      value: "1",
    },
    {
      label: "Pending",
      value: "0",
    },
    {
      label: "Failed",
      value: "2",
    },
  ];
  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => <p className="font-medium w-[150px]">{text ?? "-"}</p>,
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Member Mobile",
      dataIndex: "mobile",
      key: "mobile",
      render: (text) => <p className="w-[200px]">{text}</p>,
    },
    {
      title: "Member Id",
      dataIndex: "member_id",
      key: "member_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Beneficiary Name",
      dataIndex: "benificiary_name",
      key: "benificiary_name",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Account No",
      dataIndex: "benificiary_account",
      key: "benificiary_account",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Remitter Name",
      dataIndex: "remitter_name",
      key: "remitter_name",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ?? "-"}
        </p>
      ),
    },
    {
      title: "Remitter Mobile",
      dataIndex: "remitter_mobile",
      key: "remitter_mobile",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ?? "-"}
        </p>
      ),
    },
    {
      title: "IFSC Code",
      dataIndex: "benificiary_ifsc",
      key: "benificiary_ifsc",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <p style={{ width: "50px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    // {
    //   title: "Surcharge",
    //   dataIndex: "surcharge",
    //   key: "surcharge",
    //   render: (text) => (
    //     <p style={{ width: "50px" }} className=" font-medium">
    //       {text} Rs.
    //     </p>
    //   ),
    // },
    {
      title: "RRN",
      dataIndex: "rrn",
      key: "rrn",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ? text : "-"}
        </p>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[200px] overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return (
          <>
            {text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : text === "0" ? (
              <Tag color="yellow">Pending</Tag>
            ) : (
              <Tag color="red">Failed</Tag>
            )}
          </>
        );
      },
    },
    {
      title: "View Receipt",
      dataIndex: "view",
      key: "view",
      render: (text, record) => {
        return (
          <div
            className="border border-gray-300 p-2 flex justify-center items-center rounded-md cursor-pointer"
            onClick={() => {
              setResult({
                data: {
                  "Member Mobile": record.mobile ?? "-",
                  Date: record.Date,
                  "Benificiary Name": record.benificiary_name,
                  "Account No.": record.benificiary_account,
                  "Benificiary IFSC": record.benificiary_ifsc,
                  "Remitter Name": record.remitter_name,
                  "Remitter Mobile": record.remitter_mobile,
                  RRN: record.rrn,
                  "Benificiary Name": record.benificiary_name,
                  // Surcharge: record.surcharge,
                  Amount: record.amount,
                  status:
                    record.status === "1"
                      ? "Success"
                      : record.status === "2"
                        ? "Failed"
                        : "Pending",
                  Remark: record.remark,
                },
                transaction_id: record.transaction_id,
              });
              setOpenReceiptDrawer(true);
            }}
          >
            <FaEye />
          </div>
        );
      },
    },
  ];
  const getMemberFilter = () => {
    getmemberFilterList()
      .then((res) =>
        setMemberOptions(
          res.data.map((i, index) => {
            return {
              label: i.display_text,
              mobile: i.mobile,
              value: i.id,
              key: i.id,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  };
  const getReport = (
    search_keyword = searchdropdown || searchKeyword,
    search_column = searchcolumn,
    status = searchdropdown,
    filter_member_id = memberTypeFilter ?? "",
    from_date = fromDate,
    to_date = toDate,
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: status,
      search_keyword: search_keyword,
      search_column: search_column,
      filter_member_id: filter_member_id,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getXpressPayoutReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalAmt(res.total_amount);
        setAmountData(res);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          }),
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getReport();
  }, [current, pageSize, memberTypeFilter]);
  useEffect(() => {
    dispatch(setselectedTab("11.11"));
    profiledetail.member_type !== "Retailer" && getMemberFilter();
  }, []);
  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">Payments Report</p>
            <div className="flex gap-2">
              <p
                onClick={() => {
                  const formdata = new FormData();
                  formdata.append("is_export", 1);
                  formdata.append("per_page", pageSize);
                  formdata.append("page_no", current);
                  axios
                    .post(
                      APIURL + Globalendpoints.xpressPayoutReport, // Replace with your actual POST endpoint

                      formdata,
                      {
                        responseType: "blob", // Important for binary files
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
                        },
                      },
                    )
                    .then((res) => {
                      // Determine file type or use default
                      const blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "xpressPayoutReport.xlsx");
                    })
                    .catch((err) => {
                      console.error("Download failed:", err);
                    });
                }}
                className="font-medium text-xs cursor-pointer bg-bsgreen hover:bg-green-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Export
              </p>
              <p
                onClick={() => {
                  getReport("", "", "", "");
                  setSearchKeyWord("");
                  setSearchColumn(null);
                  setMemberTypeFilter(null);
                  setFromDate("");
                  setToDate("");
                  setSearchdropdown(null);
                }}
                className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Clear Filter
              </p>
            </div>
          </div>
          <div
            className={`selectionFields grid grid-cols-1 gap-4 place-items-center 
  ${
    profiledetail.member_type !== "Retailer"
      ? "md:grid-cols-4"
      : "md:grid-cols-3"
  }
`}
          >
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "xpress_payout.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            {profiledetail.member_type !== "Retailer" && (
              <div className="w-full">
                <p className={`required text-textGray mt-2`}>
                  Select Member Type
                </p>
                <Select
                  showSearch
                  placeholder="Select member type"
                  value={memberTypeFilter}
                  onChange={(val) => setMemberTypeFilter(val)}
                  className="w-full mt-2"
                  options={memberOptions}
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    const label = option?.label?.toLowerCase() || "";
                    const mobile = option?.mobile?.toLowerCase() || "";

                    return (
                      label.includes(input.toLowerCase()) ||
                      mobile.includes(input.toLowerCase())
                    );
                  }}
                />
              </div>
            )}
            {searchcolumn == "xpress_payout.status" && (
              <div className="w-full">
                <p className="required text-textGray mt-2">Select Status</p>
                <Select
                  placeholder="Select search type"
                  value={searchdropdown}
                  onChange={(val) => setSearchdropdown(val)}
                  className="w-full mt-2"
                  options={dropdown}
                />
              </div>
            )}
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-between items-center mt-3">
            <CommonAmountPage amountData={amountData} />
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={" Payments Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          data={result}
        />
      )}
    </>
  );
};

export default XpressPayoutReport;
